document.addEventListener('DOMContentLoaded', function () {
  const dock = document.querySelector('mobile-dock');
  if (!dock) return;

  const menuBtn = dock.querySelector('button[aria-controls="MenuDrawer"]');
  const cartLink = dock.querySelector('a[aria-controls="CartDrawer"]');
  const searchLink = dock.querySelector('a[aria-controls="SearchDrawer"]');

  // Make it visible only on mobile
  if (window.innerWidth <= 768) {
    dock.classList.remove('invisible');
  }

  if (menuBtn) {
  menuBtn.addEventListener('click', () => {
    const menuDetails = document.querySelector('details#Details-menu-drawer-container');
    const summary = menuDetails?.querySelector('summary');

    if (summary && !menuDetails.hasAttribute('open')) {
      summary.click();
    }
  });
}

  if (cartLink) {
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.open();
      } else {
        window.location.href = cartLink.href;
      }
    });
  }

  if (searchLink) {
    searchLink.addEventListener('click', (e) => {
      e.preventDefault();
      const searchDrawer = document.querySelector('search-drawer');
      if (searchDrawer) {
        searchDrawer.open();
      } else {
        window.location.href = searchLink.href;
      }
    });
  }
});
